Number.prototype.centsToEuros = function () {
  return (this.valueOf() / 100).toFixed(2).replace('.', ',');
};
